module.exports = __webpack_public_path__ + "static/blockchain_icon-42553972a281f061b6481889f7d53c98.svg";